import React, { useContext } from 'react';
import c from 'classnames';
import { LoadableComponentContext } from '@wix/da-hooks/pkg/useLoadableComponent';
import ElementQueries from '../../../ElementQueries';
import { CommentEditorContext } from '../../../CommentEditor/context';
import s from './CommentBoxRoot.scss';
/**
 * The top component in our CommentBox tree.
 *
 * Provides an ElementsQueries component and disables theme skinning.
 */ const CommentBoxRoot = /*#__PURE__*/ React.forwardRef(({ children, className, isSmall }, ref)=>{
    const { editorId, isExpanded } = useContext(CommentEditorContext);
    const { isLoadingTriggered } = useContext(LoadableComponentContext);
    return /*#__PURE__*/ React.createElement(ElementQueries, {
        id: editorId,
        className: c('no-theme-skin', s['commentbox'], isExpanded && s['expanded'], isSmall && !(isExpanded || isLoadingTriggered) && 'small-editor', className),
        forwardedRef: ref,
        widthBreakpoints: [
            490
        ]
    }, children);
});
CommentBoxRoot.displayName = 'CommentBoxRoot';
export default CommentBoxRoot;

//# sourceMappingURL=CommentBoxRoot.js.map